<div class="dialog-container">
  <button class="close-btn" (click)="close()">
    <img src="assets/close.svg" alt="" />
  </button>
  <img class="cust-mar" src="assets/modal-warning-img.svg" alt="" />

  <h1 class="title cust-mar">{{ data.title }}</h1>
  <p class="desc mt-4">{{ data.description }}</p>
  <div class="d-flex align-items-center cust-mar">
    <input class="input-field" type="number" [(ngModel)]="data.inputValue" />
    <span> бел.р. </span>
  </div>
  <div class="row w-100 cust-mar">
    <div class="col-6">
      <!-- подтвердить -->
      <button class="primary-btn" (click)="apply()">Подтвердить</button>
    </div>
    <div class="col-6">
      <!-- закрываем без действия -->
      <button class="secondary-btn" (click)="close()">Отменить</button>
    </div>
  </div>
</div>
